import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'budget.field-1-name': {
    id: 'budget.field-1-name',
    defaultMessage: 'Item',
    description:
      'The field name (and the default value/watermark) in field #1 for this database template. In this case: Item',
  },
  'budget.field-2-name': {
    id: 'budget.field-2-name',
    defaultMessage: 'Total per year',
    description:
      'The field name (and the default value/watermark) in field #2 for this database template. In this case: Total per year',
  },
  'budget.field-3-name': {
    id: 'budget.field-3-name',
    defaultMessage: 'Spent this year',
    description:
      'The field name (and the default value/watermark) in field #3 for this database template. In this case: Spent this year',
  },
  'budget.field-4-name': {
    id: 'budget.field-4-name',
    defaultMessage: 'Remaining this year',
    description:
      'The field name (and the default value/watermark) in field #4 for this database template. In this case: Remaining this year',
  },
  'budget.field-5-name': {
    id: 'budget.field-5-name',
    defaultMessage: 'Status',
    description:
      'The field name (and the default value/watermark) in field #5 for this database template. In this case: Status',
  },
  'budget.field-5-select-option-1': {
    id: 'budget.field-5-select-option-1',
    defaultMessage: 'Under budget',
    description:
      'The option value for option #1 in field #5 for this database template. In this case: Under budget',
  },
  'budget.field-5-select-option-2': {
    id: 'budget.field-5-select-option-2',
    defaultMessage: 'Over budget',
    description:
      'The option value for option #2 in field #5 for this database template. In this case: Over budget',
  },
  'budget.view-1-name': {
    id: 'budget.view-1-name',
    defaultMessage: 'All items',
    description:
      'The view name for view #1 in this template. Displayed on the top left of the screen (below the database name). In this case: All items',
  },
  'budget.entry-1-cell-1': {
    id: 'budget.entry-1-cell-1',
    defaultMessage: 'Rent',
    description:
      'The text value of cell #1 in row (entry) #1 in this database template. In this case:  Rent',
  },
  'budget.entry-2-cell-1': {
    id: 'budget.entry-2-cell-1',
    defaultMessage: 'Utilities',
    description:
      'The text value of cell #1 in row (entry) #2 in this database template. In this case:  Utilities',
  },
  'budget.entry-3-cell-1': {
    id: 'budget.entry-3-cell-1',
    defaultMessage: 'Legal Fees',
    description:
      'The text value of cell #1 in row (entry) #3 in this database template. In this case:  Legal Fees',
  },
});
